import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { matchPath } from 'react-router';
import { connect } from 'react-redux';

import PastEventList from 'components/event/PastEventList';
import {
  getPastTeamEvents,
  startDuplicatingEvent,
  searchTeamEvents,
  clearTeamEventsSearchResults
} from 'actions/Event';
import { showModal } from 'actions';
import { PAST_EVENT_FILTERS } from 'constants/EventFilters';

import Paths from 'AppPaths';

function Unconnected({
  getPastTeamEvents,
  startDuplicatingEvent,
  pastTeamEvents,
  showModal,
  teamId,
  history,
  team,
  teamEventSearchResults,
  searchTeamEvents,
  isLoading
}) {
  const [currentPage, setCurrentPage] = useState(1);

  const { pageCount: totalPageCount, events } = useMemo(
    () => pastTeamEvents,
    [pastTeamEvents]
  );

  useEffect(() => {
    getPastTeamEvents(currentPage);
  }, [getPastTeamEvents, currentPage]);

  const loadNextEvents = useCallback(() => {
    setCurrentPage(prev => prev + 1);
  }, []);

  return (
    <PastEventList
      team={team}
      onDuplicateClick={startDuplicatingEvent}
      onRestoreClick={() => {}}
      onDeleteClick={showModal.bind(null, 'EVENT_DELETE_FORM')}
      onViewClick={event => {
        history.push(`/dash/team/${teamId}/event/${event._id}/dashboard`);
      }}
      events={events}
      filter={PAST_EVENT_FILTERS}
      searchTeamEvents={searchTeamEvents}
      clearTeamEventsSearchResults={clearTeamEventsSearchResults}
      teamEventSearchResults={teamEventSearchResults}
      history={history}
      isLoading={isLoading}
      hasMoreEvents={currentPage < totalPageCount}
      loadNextEvents={loadNextEvents}
    />
  );
}

const PropMapper = (
  { pastTeamEvents, isEventLoading, team, teamEventSearchResults },
  { match }
) => {
  const teamMatch = matchPath(match.url, {
    path: Paths.TeamDash
  });

  const teamId = teamMatch ? teamMatch.params.teamId : null;

  return {
    pastTeamEvents,
    team,
    teamId,
    teamEventSearchResults,
    isLoading: isEventLoading
  };
};

export default connect(PropMapper, {
  getPastTeamEvents,
  startDuplicatingEvent,
  showModal,
  searchTeamEvents,
  clearTeamEventsSearchResults
})(Unconnected);

export { Unconnected, PropMapper };
